import { Accordion, CtaButton, Grid } from '@zappyrent/hundop';
import {
  I18nextContext,
  Trans,
  useTranslation,
} from 'gatsby-plugin-react-i18next';
import { toUpper } from 'lodash';
import React, { useContext } from 'react';

import useUtmQueryString from '../../../hooks/useUtmQueryString';
import {
  StyledCtaButtonWrapper,
  StyledParagraph,
} from './ReferALandlordFaq.styles';

const ReferALandlordFaqText = (): JSX.Element => {
  const { language } = useContext(I18nextContext);
  const { t } = useTranslation(['a11y', 'product', 'navigation']);
  const utmQueryString = useUtmQueryString('referral');

  return (
    <Grid container>
      <StyledParagraph>{t('product:referALandlordFaqText')}</StyledParagraph>
      <Accordion
        ariaLabel={t('a11y:showHide')}
        autoClose
        content={[
          {
            title: t('product:referALandlordFaqQuestion1'),
            body: (
              <Trans
                components={{
                  a: <a />,
                }}
                i18nKey="product:referALandlordFaqAnswer1"
                t={t}
              />
            ),
          },
          /* {
            title: t('product:referALandlordFaqQuestion2'),
            body: t('product:referALandlordFaqAnswer2'),
          }, */
          {
            title: t('product:referALandlordFaqQuestion3'),
            body: (
              <Trans
                components={{
                  a: <a />,
                  li: <li />,
                  ul: <ul />,
                }}
                i18nKey="product:referALandlordFaqAnswer3"
                t={t}
              />
            ),
          },
          {
            title: t('product:referALandlordFaqQuestion4'),
            body: (
              <Trans
                components={{
                  a: <a />,
                }}
                i18nKey="product:referALandlordFaqAnswer4"
                t={t}
              />
            ),
          },
          {
            title: t('product:referALandlordFaqQuestion5'),
            body: (
              <Trans
                components={{
                  a: <a />,
                }}
                i18nKey="product:referALandlordFaqAnswer5"
                t={t}
              />
            ),
          },
          {
            title: t('product:referALandlordFaqQuestion6'),
            body: <Trans i18nKey="product:referALandlordFaqAnswer6" t={t} />,
          },
          {
            title: t('product:referALandlordFaqQuestion7'),
            body: (
              <Trans
                components={{
                  a: <a />,
                }}
                i18nKey="product:referALandlordFaqAnswer7"
                t={t}
              />
            ),
          },
          {
            title: t('product:referALandlordFaqQuestion8'),
            body: (
              <Trans
                components={{
                  a: <a />,
                }}
                i18nKey="product:referALandlordFaqAnswer8"
                t={t}
                values={{
                  link: t('navigation:referralProgramTermsAndConditionsLink'),
                }}
              />
            ),
          },
          {
            title: t('product:referALandlordFaqQuestion9'),
            body: (
              <Trans
                components={{
                  a: <a />,
                  li: <li />,
                  ul: <ul />,
                  strong: <strong />,
                }}
                i18nKey="product:referALandlordFaqAnswer9"
                t={t}
              />
            ),
          },
          {
            title: t('product:referALandlordFaqQuestion10'),
            body: <Trans i18nKey="product:referALandlordFaqAnswer10" t={t} />,
          },
          {
            title: t('product:referALandlordFaqQuestion11'),
            body: <Trans i18nKey="product:referALandlordFaqAnswer11" t={t} />,
          },
        ]}
        id="invite-a-landlord-accordion"
      />
      <StyledCtaButtonWrapper>
        <CtaButton
          href={`${process.env.GATSBY_REFERRAL_PROGRAM_URL}/${language}?${utmQueryString}`}
          tag="a"
          title={t('product:inviteALandlord')}
          user="landlord"
          width="100%"
        >
          {toUpper(t('product:inviteALandlord'))}
        </CtaButton>
      </StyledCtaButtonWrapper>
    </Grid>
  );
};

export default ReferALandlordFaqText;
